import type { ReactElement } from 'react';

import { Box, Flex, Skeleton } from '@rango-dev/whale';
import React from 'react';

import styles from './ArticleSkeleton.module.css';

const BODY_LINE_WIDTHS = ['100%', '96%', '92%', '70%'];

function TextBlock(): ReactElement {
  return (
    <Flex direction="column" gap="4" width="100%">
      <Skeleton width={{ initial: '60%', md: '40%' }} height={{ initial: '28px', md: '36px' }} />
      <Flex direction="column" gap="2" width="100%">
        {BODY_LINE_WIDTHS.map((width) => (
          <Skeleton key={`article-line-${width}`} width={width} height="18px" />
        ))}
      </Flex>
    </Flex>
  );
}

export function ArticleSkeleton(): ReactElement {
  return (
    <Box className={styles.container}>
      <Flex direction="column" gap="6" className={styles.content}>
        <TextBlock />
        <Skeleton width="100%" height={{ initial: '240px', md: '500px' }} />
        <TextBlock />
        <Skeleton width="100%" height="112px" />
        <TextBlock />
        <Flex direction="column" align="center" gap="4" width="100%" pt="2">
          <Skeleton width={{ initial: '80%', md: '434px' }} height="28px" />
          <Skeleton width="115px" height="40px" />
        </Flex>
      </Flex>
    </Box>
  );
}
